import * as React from 'react'
import { isProd, styling } from 'common/utils'
import { DynamicCx } from 'common/types'
import * as s from './gnb.scss'
import OutsideClick from 'common/components/OutsideClick'

interface State {
  activate: boolean
}

interface OwnProps {
  cx?: DynamicCx
}

type Props = OwnProps

@styling(s)
export default class MyButton extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activate: false,
    }
  }

  render() {
    const { cx } = this.props
    const shoppingMyUrl = isProd ? 'https://shopping.naver.com' : 'http://test.shopping.naver.com'
    const payBenefitUrl = isProd ? 'https://benefit.pay.naver.com' : 'https://dev-benefit.pay.naver.com'
    const payOrderUrl = isProd ? 'https://order.pay.naver.com' : 'https://dev-order.pay.naver.com'

    const handleButtonClick = () => {
      this.setState(prevState => ({ activate: !prevState.activate }))
    }

    return (
      <div className={cx('shop_my')}>
        <button
          type="button"
          className={cx('btn_my', { active: this.state.activate }, '@N=a:SNB.shoppingmy')}
          onClick={handleButtonClick}>
          쇼핑MY
        </button>
        <OutsideClick
          className={cx('layer_my')}
          onClickOutside={handleButtonClick}
          isRendered={this.state.activate}
          stopPropagation={false}>
          <ul className={cx('list_my')}>
            <li>
              <a href={`${shoppingMyUrl}/my/p/home.nhn`} className={cx('@N=a:SNB*m.home')}>
                MY 홈
              </a>
            </li>
            <li>
              <a href={`${shoppingMyUrl}/my/p/zzim/index.nhn`} className={cx('@N=a:SNB*m.my')}>
                찜한 상품
              </a>
            </li>
            <li>
              <a href={`${shoppingMyUrl}/my/p/store/list.nhn`} className={cx('@N=a:SNB*m.shop')}>
                단골 스토어
              </a>
            </li>
            <li>
              <a href={`${payOrderUrl}/main/cart`} className={cx('@N=a:SNB*m.cart')}>
                장바구니
              </a>
            </li>
            <li>
              <a href={`${payOrderUrl}/home?tabMenu=SHOPPING`} className={cx('@N=a:SNB*m.order')}>
                주문확인/배송조회
              </a>
            </li>
            <li>
              <a href={`${payBenefitUrl}/coupon`} className={cx('@N=a:SNB*m.coupon')}>
                쿠폰
              </a>
            </li>
          </ul>
        </OutsideClick>
      </div>
    )
  }
}
